// alert.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AlertDataI {
  type: 'success' | 'error' | 'warning' | 'info' | 'alternate';
  view?: 'snackbar' | 'modal';
  title?: string;
  message: string;
  autoDismiss?: boolean;
  position?:
    | 'top-center'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'bottom-center';
}

@Injectable({ providedIn: 'root' })
export class AlertService2 {
  private alertSubject = new Subject<AlertDataI>();
  alert$ = this.alertSubject.asObservable();

  showAlert(data: AlertDataI) {
    this.alertSubject.next({
      position: 'top-center',
      autoDismiss: true,
      ...data,
    });
  }
}
